export default "__VITE_ASSET__Bqdc1e1x__"